import React from 'react'
import {
  SpacerVertical,
  View,
  Stepper
} from '@klarna/bubble-ui'

import { interpolateContent } from '../../utils'
import content from '../../content'

interface CheckoutTimelineCopy {
  heading: string
  paragraph?: string
}

interface LearnMoreTimelineProps {
  copy: CheckoutTimelineCopy[]
}

export const CheckoutTimeline = ({ copy }: LearnMoreTimelineProps) => {
  if (!copy) return null

  // TODO: Check warning ***Warning: Invalid prop `entries[0].title` of type `array` supplied to `Timeline`, expected `string`.***
  const entries = copy.map((step: CheckoutTimelineCopy, index: number) => (
    <Stepper.Item key={index}
      // @ts-ignore
      title={interpolateContent(step.heading, content)}
      description={step.paragraph ? interpolateContent(step.paragraph) : ''} />
  ))

  return (
    <View>
      <SpacerVertical spaceToken="space.200"/>
      <Stepper>
        {entries}
      </Stepper>
      <SpacerVertical spaceToken="space.200"/>
    </View>
  )
}
